const ALL_CURRENCIES = 'All currencies';
const PROJECT = 'Project';
const CASH_RECEIPT_FROM_CUSTOMERS = 'Cash receipt from customers';
const WAGES_AND_SALARIES = 'Wages and salaries';
const EXPENSES = 'Expenses';
const EXTRA_INCOME = 'Extra Income';
const INVESTMENTS = 'Investments';
const DISTRIBUTIONS = 'Distributions';
const INCOME_TAXES_PAID = 'Income taxes paid';
const ACTUAL_ENDING_CASH_BALANCE = 'Actual ending cash balance';
const BALANCE_CHANGES = 'Balance changes';
const DISCREPANCY = 'Discrepancy';
const NET_CASH_FLOW = 'Net cash flow';
const CASH_RECEIVED = 'Cash received';
const CASH_GENERATED_BY_THE_PROJECT = 'Cash generated by the project';
const EXCHANGE_OPERATIONS = 'Exchange operations';
const ONE_CURRENCY = 'oneCurrency';
const MOBILE_WIDTH_BREAKPOINT = 768;
const MONTHS = 'MONTHS';
const QUARTERS = 'QUARTERS';
const YEARS = 'YEARS';
const SHOW_ON_DEV = process.env.NODE_ENV === 'development';
const REVENUE = 'Revenue';
const OTHER_INCOME = 'Other Income';
const DIRECT_COSTS = 'Direct costs';
const SALARIES_OF_ASSIGNED_EMPLOYEES = 'Salaries of assigned employees';
const PROJECT_EXPENSES = 'Project expenses ';
const GROSS_INCOME = 'Gross Income';
const INDIRECT_COSTS = 'Indirect costs';
const ADMINISTRATIVE_PERSONNEL = 'Administrative personnel';
const EMPLOYEES_ON_BENCH = 'Employees on bench';
const NET_INCOME = 'Net Income';
const SALARIES = 'Salaries';

export {
  ALL_CURRENCIES,
  PROJECT,
  CASH_RECEIPT_FROM_CUSTOMERS,
  WAGES_AND_SALARIES,
  EXPENSES,
  EXTRA_INCOME,
  INVESTMENTS,
  DISTRIBUTIONS,
  INCOME_TAXES_PAID,
  ACTUAL_ENDING_CASH_BALANCE,
  BALANCE_CHANGES,
  DISCREPANCY,
  NET_CASH_FLOW,
  CASH_RECEIVED,
  CASH_GENERATED_BY_THE_PROJECT,
  EXCHANGE_OPERATIONS,
  MOBILE_WIDTH_BREAKPOINT,
  ONE_CURRENCY,
  MONTHS,
  QUARTERS,
  YEARS,
  SHOW_ON_DEV,
  REVENUE,
  OTHER_INCOME,
  DIRECT_COSTS,
  SALARIES_OF_ASSIGNED_EMPLOYEES,
  PROJECT_EXPENSES,
  GROSS_INCOME,
  INDIRECT_COSTS,
  ADMINISTRATIVE_PERSONNEL,
  EMPLOYEES_ON_BENCH,
  NET_INCOME,
  SALARIES,
};
